import { StockApiService } from './../../../../service/api/stock-api.service';
import { BaseListView } from './../../../base-listview';
import { ProductosModel } from '../../../../models/productos/productos.model';
import { Filtering } from './../../../../service/filtering/filtering';
import { FincasModel } from './../../../../models/form-common/fincas.module';
import { FormCommonApiService } from './../../../../service/api/formcommon-api.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../../../../service/events/dashboard.service';
import { FincasApiService } from 'src/app/service/api/fincas-api.service';

import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ProductosList } from 'src/app/models/stock/productos-list.model';
import { MessageModule } from 'primeng/message';
import { Uso } from 'src/app/models/productos/uso.model';
import { TreeNode } from 'primeng/api';
import { DropdownData } from '@fitogest/reactive-form-builder/interfaces';

@Component({
    selector: 'app-stock-formulario-productos',
    standalone: false,
    templateUrl: './stock-formulario-productos.component.html',
    styleUrls: ['./stock-formulario-productos.component.scss']
})
export class StockFormularioProductosComponent extends BaseListView<ProductosModel> implements OnInit {
  
    public cols: ColInterface[] = [
        {field: 'n_registro', header: 'N Registro', filter: ''},
        {field: 'nombre', header: 'Nombre', filter: ''},
        {field: 'formulado', header: 'Formulado', filter: ''},
        {field: 'titular', header: 'Titular', filter: ''},
        {field: 'ficha', header: 'Ficha Técnica', filter: ''}
    ];

    public date: Date = new Date();
  
    public fincas: DropdownData<FincasModel> = {
        filtered: [],
        values: []
    };

    public productos: DropdownData<ProductosList> = {
        filtered: [{label: 'Cargando...', value: null}],
        values: []
    };

    public usos: DropdownData<Uso> = {
        filtered: [{ label: 'Cargando...', value: null}],
        values: []
    };
    public usosFilter: Filtering<DropdownData<Uso>> = new Filtering<DropdownData<Uso>>();

    public agentes: DropdownData<Uso> = {
        filtered: [{ label: 'Cargando...', value: null}],
        values: []
    };
    public agentesFilter: Filtering<DropdownData<Uso>> = new Filtering<DropdownData<Uso>>();
  
    public estado: DropdownData<string> = {
        filtered: [],
        values: [
            { label: 'Estado...', value: '' },
            { label: 'Activo', value: 'SI' },
            { label: 'No Activo', value: 'NO' },
        ]
    };

    public aplicacion = '';

    private selectedProductoValue: ProductosList | null = null;
    private selectedUsoValue: Uso | null = null;
    private selectedAgenteValue: Uso | null = null;
    private selectedFincaValue: FincasModel | null = null;
    private selectedEstadoValue: string | null = null;

    public data: ProductosList = {
        precio: 0,
        unidades: '',
        n: '',
        p: '',
        k: '',
        observaciones: ''
    };

    public msgs: MessageModule[] = [];

    public get selectedProducto(): ProductosList | null {
        return this.selectedProductoValue;
    }

    public set selectedProducto(value: ProductosList | null) {
        this.selectedProductoValue = value;
    }

    public get selectedUso(): Uso | null {
        return this.selectedUsoValue;
    }

    public set selectedUso(value: Uso | null) {
        this.selectedUsoValue = value;
    }

    public get selectedAgente(): Uso | null {
        return this.selectedAgenteValue;
    }

    public set selectedAgente(value: Uso | null) {
        this.selectedAgenteValue = value;
    }

    public get selectedFinca(): FincasModel | null {
        return this.selectedFincaValue;
    }

    public set selectedFinca(value: FincasModel | null) {
        this.selectedFincaValue = value;
    }

    public get selectedEstado(): string | null {
        return this.selectedEstadoValue;
    }

    public set selectedEstado(value: string | null) {
        this.selectedEstadoValue = value;
    }

    public get producto(): ProductosList {
        return this.selectedProducto ?? {} as ProductosList;
    }

    public get agente(): Uso {
        return this.selectedAgente ?? {} as Uso;
    }

    constructor(private dashboardEvents: DashboardService,
        private formApi: FormCommonApiService,
        private fincasApi: FincasApiService,
        public stockApi: StockApiService,
        private router: Router) {
        super(formApi.magramaProducto);
    }

    public static createNavigation(router: Router) {
        router.navigate(['register']);
    }

    ngOnInit() {
        this.dashboardEvents.setHeaderTitle('Nuevo Producto');
        this.initFormData();
        this.initFormFiltering();
    }

    onSubmit() {
        const producto: ProductosModel = {
            num_registro: +(this.selectedProducto?.n_registro ?? ''),
            materia_activa: this.selectedAgente?.composicion,
            ps: this.selectedAgente?.plazo_seguridad,
            nombre: this.selectedProducto?.nombre ?? '',
            finca: this.selectedFinca?.id ?? '',
            estado: this.selectedEstado ?? '',
            precio: this.data?.precio ?? 0,
            unidades: this.data.unidades,
            N: this.data.n,
            P: this.data.p,
            K: this.data.k,
            observaciones: this.data.observaciones,
            tipo: '',
            fecha_caducidad: ''
        };

        this.stockApi.productosPost.safePerform(producto as never);
        this.stockApi.productosPost.response(() => {

            if (this.stockApi.productosPost.hasError){
                this.msgs.push({severity: 'error', summary: 'Error', detail: 'No se ha podido crear el producto'});
            } else {
                this.msgs.push({severity: 'success', summary: 'Guardad', detail: 'El producto se ha guardado satisfactoriamente'});
            }
        });
    }
  
    public goBack(){
        this.router.navigate(['dashboard', 'stock-productos']);
    }
  
    public applyFilters(){
        if (this.usosFilter) { this.usosFilter.filter(); }
        if (this.agentesFilter) { this.agentesFilter.filter(); }
    }

    private initFormFiltering(){
        this.usosFilter.addFilter((_data: TreeNode<DropdownData<Uso>>[] | void, self: Filtering<DropdownData<Uso>> | void) => {
            const selectedProducto = this.selectedProducto;

            if (selectedProducto && self) {
                const copy = this.usos.values
                    .filter(uso => self.like(
                        uso.value?.num_registro ?? '', 
                        selectedProducto.n_registro ?? '')
                    );

                const currentUsos: string[] = [];
        
                this.usos.filtered = copy.filter((uso) => {
                    if (!currentUsos.includes(uso.label)){
                        currentUsos.push(uso.label);
                        return true;
                    } else {
                        return false;
                    }
                });

                try {
                    this.aplicacion = this.usos.filtered[0]?.value?.aplicacion ?? '';
                } catch (e){
                    console.log(e);
                    this.aplicacion = '';
                }

                this.usos.filtered.unshift({label: 'Usos...', value: null});
            } else {
                this.usos.filtered = [{label: 'Debe seleccionar un producto...', value: null}];
            }
        });

        this.agentesFilter.addFilter(() => {
            const selectedUso = this.selectedUso;

            if (selectedUso) {
                const copy = this.agentes.values
                    .filter(agente => agente.value?.id_uso === selectedUso.id_uso
              && agente.value?.num_registro === selectedUso.num_registro);
          
                this.agentes.filtered = copy;
                this.agentes.filtered.unshift({label: 'Agente...', value: null});
            } else {
                this.agentes.filtered = [{label: 'Debe seleccionar un uso...', value: null}];
            }
        });
    }
  
    private initFormData(){
        //FINCAS
        this.fincasApi.fincasGET.safePerform();
        this.fincasApi.fincasGET.response((value: FincasModel[]) => {
            if (value){
                this.fincas.values = value.map(it => (
                    {label: it.nombre, value: it})
                );

                this.fincas.values.unshift({label: 'Finca...', value: null});
            }
        });

        //DETALLE PRODUCTOS
        this.formApi.magramaDetalleProducto.safePerform();
        this.formApi.magramaDetalleProducto.response((value: Uso[]) => {
            if (value){
                this.usos.values = value.map(it => (
                    {label: it.uso, value: it})
                );
                this.agentes.values = value.map(it => (
                    {label: it.agente, value: it})
                );

                this.usosFilter.setValue([this.usos]);
                this.agentesFilter.setValue([this.agentes]);
                this.applyFilters();
            }
        });
    }
}
